import { RIGHTWARDS_ARROW } from 'constants/entities';
import React from 'react';
import { Text } from '@landr/maestro';
import { Trans } from '@lingui/macro';
import { RouterLink } from 'components/CommonUi/RouterLink';
import { InstrumentationOptions } from 'types';
import { useGenericCarouselContext } from '../GenericCarouselContext';

export const SeeMore = () => {
    const { carouselName, carouselId, carouselUrl, linkLocation } =
        useGenericCarouselContext();

    if (!carouselUrl || linkLocation !== 'SeeMore') {
        return null;
    }

    // ANALYTICS
    const instrumentationOptions: InstrumentationOptions = {
        goal: 'See more',
        interactionSource: `See more`,
        ...(carouselName && { 'L - Carousel Name': carouselName }),
        ...(carouselId && { 'L - Carousel ID': carouselId }),
    };

    return (
        <Text>
            <RouterLink
                to={carouselUrl}
                instrumentationOptions={instrumentationOptions}
            >
                <Trans>See more</Trans> {RIGHTWARDS_ARROW}
            </RouterLink>{' '}
        </Text>
    );
};
